/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import React from "react";
import SafeLink from "components/commons/SafeLink";
import PropTypes from "prop-types";
import styled from "styled-components";
import {
  PrimaryText,
  SecondaryText
} from "components/Text";
import {Dot} from "components";
import {colors} from "nxtconstants";
import {WealthyEnv} from "helpers";


const propTypes = {
  content: PropTypes.array.isRequired
};

const defaultProps = {
  content: []
};

const Newsletter = ({content}) => {
  const data = [];
  content.map((datum) => {
    const newsletterThumbnail = datum.imageUrl || `${WealthyEnv.CDN_URL}/newsletter/ticket.png`;
    data.push((
      <NewsletterArticle
        className="newsletter-article"
        key={datum.id}
      >
        <div className="newsletter-thumbnail">
          <img
            alt="news letter thumbnail"
            className="newsletter-thumbnail__image"
            loading="lazy"
            src={newsletterThumbnail}
          />
        </div>
        <div className="newsletter-content">
          <div className="newsletter-title">
            <PrimaryText
              additionalStyles="text-transform: uppercase; font-weight: 700" className="newsletter-title__tag"
              color={colors.razzmatazz}
            >
              {"MONEY ORDER"}
            </PrimaryText>
            <SafeLink
              className="newsletter-title__link"
              href={`/newsletters/${datum.slug}-${datum.id}`}
            >
              <SecondaryText
                additionalStyles="line-height: 3rem;"
                className="newsletter-title__heading"
                color={colors.luckyPoint}
                fontSize="2.3rem"
              >
                {datum.title}
              </SecondaryText>
            </SafeLink>
          </div>
          <div className="newsletter-footer">
            <PrimaryText
              additionalStyles="text-transform: capitalize"
              className="newsletter-footer__text"
              color={colors.gray}
            >
              By {"Team Wealthy"}
            </PrimaryText>
            <hr className="newsletter-divider" />
            <div
              style={{
                display: "flex",
                alignItems: "center"
              }}
            >
              <PrimaryText
                className="newsletter-footer__text"
                color={colors.gray}
              >
                {datum.readTime || "0"} mins read
              </PrimaryText>
            </div>
          </div>
        </div>
      </NewsletterArticle>
    ));
  });

  return (
    <div className="newsletter-container">
      <SecondaryText
        className="newsletter-heading"
        fontSize="1.8rem"
      >
        WEEKLY NEWSLETTER
      </SecondaryText>
      <Title> Money Order</Title>
      {data}
      <SafeLink
        className="load-more__btn"
        href="/money-order"
      >
        <SecondaryText
          className="load-more__text"
          color={colors.luckyPoint}
        >
        Load More
        </SecondaryText>
        <div className="arrow__right--medium-container">
          <span className="arrow__right--medium" />
        </div>
      </SafeLink>
    </div>
  );
};

const NewsletterArticle = styled.article`
`;
const Title = styled.h2 `
  font-family: Avenir-Heavy;
  font-weight: initial;
  color: #263276;
  font-size: 3.2rem;
  line-height: calc(3.2rem * 1.5);
  margin: 1rem 0 2rem 0;
`;


Newsletter.propTypes = propTypes;
Newsletter.defaultProps = defaultProps;

export default Newsletter;
